import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import BaseFullscreenDialog from '~/core/components/Base/BaseFullscreenDialog.vue';
import { ML_URL, PB_URL, PT_URL } from '~/core/constants';
import useLocaleStore from '~/stores/useLocaleStore';

/** Служит для отображения полноэкранного диалога со списком проектов. */
export default defineComponent({
  name: 'OurProjectsDialog',
  components: {
    BaseFullscreenDialog: BaseFullscreenDialog
  },
  props: {
    /** Определяет, является ли диалог с проектами активным. */
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click:close'],
  setup: function setup(_, _ref) {
    var emit = _ref.emit;
    var locale = useLocaleStore();
    var title = 'Наши проекты';
    var projects = computed(function () {
      return [{
        name: 'prodoctorov',
        logo: locale.pdLogo,
        description: 'Сайт отзывов о врачах №1 в России',
        url: locale.pdUrl
      }].concat(_toConsumableArray(locale.isRu ? [{
        name: 'protabletky',
        logo: '/graphics/logo/protabletky.svg',
        description: 'Сайт отзывов врачей о лекарствах',
        url: PT_URL
      }, {
        name: 'probolezny',
        logo: '/graphics/logo/probolezny.svg',
        description: 'Научно-популярная энциклопедия заболеваний',
        url: PB_URL
      }, {
        name: 'medlock',
        logo: '/graphics/logo/medlock.svg',
        description: 'Медицинская информационная система',
        url: ML_URL
      }] : []));
    });
    function handleClose() {
      emit('click:close');
    }
    function goToProject(url) {
      location.assign(url);
    }
    return {
      title: title,
      projects: projects,
      handleClose: handleClose,
      goToProject: goToProject
    };
  }
});